import { useEffect } from 'react';
import Modal from './modal';
import { useAuth } from '../../../lib/auth';
import { ButtonLink, P } from '../../../lib/ui';
import { savePublicEditorDraft } from '../../public-editor-draft';

function PublicEditorPromptModal({
  toggle,
  isOpen,
  rawTemplate,
  css,
}: {
  toggle: () => void;
  isOpen: boolean;
  rawTemplate?: string;
  css?: string;
}) {
  const { user, reload } = useAuth();
  useEffect(() => {
    const reloadIfNeeded = async () => {
      if (isOpen && !user) {
        await reload();
      }
    };

    reloadIfNeeded();
  }, [user, isOpen]);

  const saveDraft = () => {
    savePublicEditorDraft(rawTemplate, css);
  };

  return (
    <Modal toggle={toggle} isOpen={isOpen} size="sm:max-w-lg" closeButton>
      <div className="text-left">
        <div className="sm:flex sm:items-start mb-4">
          <h3
            className="text-base font-semibold tracking-tight text-neutral-900"
            id="modal-headline">
            👋 Welcome to Postdrop
          </h3>
        </div>
        <div>
          <P>
            To save templates or send test email you need to have an account so
            we can verify your email.
          </P>
          <P>Sign up or log in to try out all the features.</P>
        </div>
        <div className="mt-6 mb-1 flex gap-2">
          <ButtonLink href="/signup" target="_blank" onClick={saveDraft}>
            Sign Up For Free
          </ButtonLink>
          <ButtonLink outline className="ml-2" href="/login" target="_blank" onClick={saveDraft}>
            Login
          </ButtonLink>
        </div>
      </div>
    </Modal>
  );
}

export default PublicEditorPromptModal;
